import React, { useState, useEffect } from 'react';
import { getTranslations } from '../../../../../../services/languageUtils';

function TransferTypePixLimits({ handleChange, resetPixSettings, savePixLimitSettings, valueDayCnpj, valueNightPayments, valueNightCpf, valueNightCnpj, valueDayPayments, valueDayCpf }){
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations((localStorage.getItem('language') || 'pt'));
      setTranslations(trans);
    };
    loadTranslations();
  }, []);
  
  return (
    <div>
      <span className="desktop">
        <div>
          <div className="mainContent100">
            <div className="spaceAround">
              <div className="contentSlider" style={{width: "200px"}}>
                <p className="pTitle">
                  {translations.type_of_transfer}
                </p>
              </div>
              <div className="contentSlider" style={{paddingRight: "0px"}}>
                <b>{translations.day_limit}</b> | 06:00 am to 08:00 pm
              </div>
              <div className="contentSlider" style={{paddingRight: "0px"}}>
                <b>{translations.night_limit}</b> | 08:01 pm to 05:59 am
              </div>
            </div>

            <div className="spaceAround">
              <div className="contentSlider" style={{width: "200px"}}>
                <b>{translations.cpf}</b><br/>{translations.non_legal_persons}
              </div>
              <div className="contentSlider">
                <p>
                  <b>{Number(valueDayCpf).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
                </p>
                <input
                  type="range"
                  id="rangeSlider"
                  min={0}
                  max={100000}
                  step={100}
                  value={valueDayCpf}
                  onChange={(e)=>handleChange(e.target.value, "dayCpf")}
                  style={{ width: '100%', marginTop: '10px' }}
                />
              </div>
              <div className="contentSlider">
                <p>
                  <b>{Number(valueNightCpf).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
                </p>
                <input
                  type="range"
                  id="rangeSlider"
                  min={0}
                  max={100000}
                  step={100}
                  value={valueNightCpf}
                  onChange={(e)=>handleChange(e.target.value, "nightCpf")}
                  style={{ width: '100%', marginTop: '10px' }}
                />
              </div>
            </div>

            <div className="spaceAround">
              <div className="contentSlider" style={{width: "200px"}}>
                <b>{translations.cnpj}</b><br/>{translations.companies}
              </div>
              <div className="contentSlider">
                <p>
                  <b>{Number(valueDayCnpj).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
                </p>
                <input
                  type="range"
                  id="rangeSlider"
                  min={0}
                  max={100000}
                  step={100}
                  value={valueDayCnpj}
                  onChange={(e)=>handleChange(e.target.value, "dayCnpj")}
                  style={{ width: '100%', marginTop: '10px' }}
                />
              </div>
              <div className="contentSlider">
                <p>
                  <b>{Number(valueNightCnpj).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
                </p>
                <input
                  type="range"
                  id="rangeSlider"
                  min={0}
                  max={100000}
                  step={100}
                  value={valueNightCnpj}
                  onChange={(e)=>handleChange(e.target.value, "nightCnpj")}
                  style={{ width: '100%', marginTop: '10px' }}
                />
              </div>
            </div>

            <div className="spaceAround">
              <div className="contentSlider" style={{width: "200px"}}>
                <b>{translations.payments}</b>
              </div>
              <div className="contentSlider">
                <p>
                  <b>{Number(valueDayPayments).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
                </p>
                <input
                  type="range"
                  id="rangeSlider"
                  min={0}
                  max={100000}
                  step={100}
                  value={valueDayPayments}
                  onChange={(e)=>handleChange(e.target.value, "dayPayments")}
                  style={{ width: '100%', marginTop: '10px' }}
                />
              </div>
              <div className="contentSlider">
                <p>
                  <b>{Number(valueNightPayments).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
                </p>
                <input
                  type="range"
                  id="rangeSlider"
                  min={0}
                  max={100000}
                  step={100}
                  value={valueNightPayments}
                  onChange={(e)=>handleChange(e.target.value, "nightPayments")}
                  style={{ width: '100%', marginTop: '10px' }}
                />
              </div>
            </div>

            <div style={{display: "flex", justifyContent: "space-between"}}>
              <div style={{position: "relative", top: "5px"}} onClick={() => {resetPixSettings()}} className="backButton">
                {translations.reset_to_settings_recommendation}
              </div>
              <div onClick={() => {savePixLimitSettings()}} className="buttonSendConfigPix">
                {translations.save_changes}
              </div>
            </div>
          </div>
        </div>
      </span>

      <span className="mobile">
        <div>
          <div className="mainContent100">
            <div className="contentSlider" style={{paddingRight: "0px"}}>
              <b>{translations.day_limit}</b> | 06:00 am to 08:00 pm
            </div><br/>

            <b>{translations.cnpj}</b> ({translations.companies})<br/>
            <div className="contentSlider" style={{width: "95%"}}>
              <p>
                <b>{Number(valueDayCnpj).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
              </p>
              <input
                type="range"
                id="rangeSlider"
                min={0}
                max={100000}
                step={100}
                value={valueDayCnpj}
                onChange={(e)=>handleChange(e.target.value, "dayCnpj")}
                style={{ width: '100%', marginTop: '10px' }}
              />
            </div><br/>

            <b>{translations.cpf}</b> ({translations.non_legal_persons})<br/>
            <div className="contentSlider" style={{width: "95%"}}>
              <p>
                <b>{Number(valueDayCpf).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
              </p>
              <input
                type="range"
                id="rangeSlider"
                min={0}
                max={100000}
                step={100}
                value={valueDayCpf}
                onChange={(e)=>handleChange(e.target.value, "dayCpf")}
                style={{ width: '100%', marginTop: '10px' }}
              />
            </div><br/>

            <b>{translations.payments}</b><br/>
            <div className="contentSlider" style={{width: "95%"}}>
              <p>
                <b>{Number(valueDayPayments).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
              </p>
              <input
                type="range"
                id="rangeSlider"
                min={0}
                max={100000}
                step={100}
                value={valueDayPayments}
                onChange={(e)=>handleChange(e.target.value, "dayPayments")}
                style={{ width: '100%', marginTop: '10px' }}
              />
            </div><br/>

            <div className="contentSlider" style={{paddingRight: "0px", borderTop: "1px solid #EBEBED", paddingTop: "25px", width: "95%"}}>
              <b>{translations.night_limit}</b> | 08:01 am to 05:59 pm
            </div><br/>

            <b>{translations.cnpj}</b> ({translations.companies})<br/>
            <div className="contentSlider" style={{width: "95%"}}>
              <p>
                <b>{Number(valueNightCnpj).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
              </p>
              <input
                type="range"
                id="rangeSlider"
                min={0}
                max={100000}
                step={100}
                value={valueNightCnpj}
                onChange={(e)=>handleChange(e.target.value, "nightCnpj")}
                style={{ width: '100%', marginTop: '10px' }}
              />
            </div><br/>

            <b>{translations.cpf}</b> ({translations.non_legal_persons})<br/>
            <div className="contentSlider" style={{width: "95%"}}>
              <p>
                <b>{Number(valueNightCpf).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
              </p>
              <input
                type="range"
                id="rangeSlider"
                min={0}
                max={100000}
                step={100}
                value={valueNightCpf}
                onChange={(e)=>handleChange(e.target.value, "nightCpf")}
                style={{ width: '100%', marginTop: '10px' }}
              />
            </div><br/>

            <b>{translations.payments}</b><br/>
            <div className="contentSlider" style={{width: "95%"}}>
              <p>
                <b>{Number(valueNightPayments).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}</b> <span style={{fontSize: "12px"}}>{translations.current_limit}</span>
              </p>
              <input
                type="range"
                id="rangeSlider"
                min={0}
                max={100000}
                step={100}
                value={valueNightPayments}
                onChange={(e)=>handleChange(e.target.value, "nightPayments")}
                style={{ width: '100%', marginTop: '10px' }}
              />
            </div><br/>

            <div style={{display: "flex", justifyContent: "space-between"}}>
              <div style={{position: "relative", top: "5px"}} onClick={() => {resetPixSettings()}} className="backButton">
                {translations.reset_to_settings_recommendation}
              </div>
              <div onClick={() => {savePixLimitSettings()}} className="buttonSendConfigPix">
                {translations.save_changes}
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>
  );
}

export default TransferTypePixLimits;
